import { apiGet } from '../../api'

export const get_program_curriculums = program_id => {
  return apiGet({
    endpoint: `curriculums/program_curriculums?program_id=${program_id}`
  })
}
